import { useMemo } from "react";
import { DateTime } from "luxon";
import {
  getLongDateFormat,
  getMomentLongDateFormat,
  getLocale,
} from "../../utils/luxonHelpers";
import i18n from "../../utils/i18n";
import BootstrapDateTimePicker from "../BootstrapDateTimePicker";

const DateAndTimeInput = ({
  type,
  selectedDate,
  selectedTime,
  event,
  onDateChange,
  onTimeBlur,
  timeInputRef,
}) => {
  // Convert selectedDate to DateTime, handling multiple input types
  let date = null;
  if (selectedDate) {
    if (selectedDate instanceof DateTime) {
      date = selectedDate;
    } else if (selectedDate instanceof Date) {
      date = DateTime.fromJSDate(selectedDate);
    } else if (typeof selectedDate === "string") {
      date = DateTime.fromISO(selectedDate);
    }
  }

  // Convert selectedTime to DateTime, handling multiple input types
  let time = null;
  if (selectedTime) {
    if (selectedTime instanceof DateTime) {
      time = selectedTime;
    } else if (selectedTime instanceof Date) {
      time = DateTime.fromJSDate(selectedTime);
    } else if (typeof selectedTime === "string") {
      time = DateTime.fromISO(selectedTime);
    }
  }

  const memoizedDatePickerOptions = useMemo(() => {
    return {
      minDate: event?.startingAt,
      maxDate: event?.endingAt,
      format: getMomentLongDateFormat(), // Use moment.js format for Bootstrap Datepicker
      locale: getLocale(),
      calendarWeeks: true,
      ignoreReadonly: true,
    };
  }, [event?.startingAt, event?.endingAt]);

  return (
    <div className="input-group">
      <BootstrapDateTimePicker
        name={type + "_date"}
        value={date ? date.toFormat(getLongDateFormat()) : ""}
        placeholder={i18n.t("schedule.shifts.form.date_placeholder")}
        options={memoizedDatePickerOptions}
        onHide={onDateChange}
      />
      <span className="input-group-addon">
        {i18n.t("schedule.shifts.form.at")}
      </span>
      <input
        type="text"
        name={type + "_time"}
        ref={timeInputRef}
        value={time ? time.toFormat("HH:mm") : ""}
        onChange={() => {}}
        onBlur={onTimeBlur}
        className="form-control time_input"
        placeholder={i18n.t("schedule.shifts.form.time_placeholder")}
      />
    </div>
  );
};

export default DateAndTimeInput;
